import { Transaction } from './transaction'

export class RecruitDetails {
	id: number
	first_name: string
	last_name: string
	recruits: [RecruitDetails]
	transactions: [Transaction]
	recruiter_sum?:number
}